import gql from 'graphql-tag';

export type SignUpUserGender = 'male' | 'female' | 'unknown';
export type SignUpDocumentType = 'cpf' | 'cnpj';

export interface SignUpMutationVariablesI {
  input: {
    username: string;
    birthDate?: string; // 1999-07-03
    gender?: SignUpUserGender;
    email: string;
    password: string;
    document: string; // only numbers
    documentType: SignUpDocumentType;
    phone?: string;
    bank?: string;
    bankType?: string;
    agency?: string;
    agencyDigit?: string;
    account?: string;
    accountDigit?: string;
    accountHolderName?: string;
    incompleteFlow?: boolean;
    customFields?: {
      key: string;
      value: string;
    }[];
    indicatedBy?: string;
    organizationId?: string;
    direct?: boolean;
  };
}

export default gql`
  mutation SignUpMutation($input: SignUpInput!) @api(name: "auth") {
    signUp(input: $input) {
      id
      username
      email
      token
    }
  }
`;
